import { EnvironmentConfiguration } from './environment.models';

export const environment = {
	production: true,
	defaultLanguage: 'en',
	server: 'https://portal-api.zone5cloud.com',
	sis: 'https://identity.specialized.com',
	brsAuthentication: 'https://portal-api-staging.zone5cloud.com', // TODO: update when ready
	registrations: 'https://api.specialized.com/bike-service/v2', // TODO: update when ready
	debug: false,
	configuration: EnvironmentConfiguration.production,
	clusterId: 'specialized-prod',
	cookieDomain: 'admin.specialized.com',

	apps: {
		portal: 'https://admin.specialized.com'
	}
};
